import React, { useEffect} from 'react'
import styled from 'styled-components'
import Vid from '../../videos/vid1.mp4'
import Vid2 from '../../videos/vid2.mp4'
import Vid3 from '../../videos/vid3.mp4'
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Navigation} from 'swiper'
import './slide.css'
import * as styles from './slide.module.scss'
const Screen = styled.div`
border-width: 1px;
max-width: 1920px;
max-height: 500px;
height: 100%;
width:100%;
`
const Grid = styled.div`
display:grid;
grid-template-columns: repeat(3, 1fr);
`
const Circle = styled.div`
    width: 50px;
    height: 50px;
    margin: 0 1rem;
    border-radius: 100%;
    background: #2a2a2a;
    cursor:pointer;
    svg{
        fill:white;
    }
    .prev-btn{
    position: absolute;
    top: 25%;
    left: 28px;
    }
    .next-btn{
    position: absolute;
    top: 25%;
    right: 28px;
    }
`
const SwipButtons= styled.div
`
position: absolute;
z-index: 10;
top: -180px;
display: flex;
width: 100%;
margin: 0 auto;
#prev{
    flex:1;
}
`
const GridMobile = styled.div`
display:grid;
  grid-template-columns: repeat(2,1fr);
`
const GridMobileSmall = styled.div`
display:grid;
  grid-template-columns: repeat(1,1fr);
`

SwiperCore.use([Navigation])
const Slide = () => {
  const navigationPrevRef = React.useRef(null)
  const navigationNextRef = React.useRef(null)
 
  useEffect(()=>
  {  
const grid1 = document.querySelectorAll('#grid')
grid1.forEach(grid =>{
  grid.addEventListener('mouseenter',e =>
  {
    const vid = e.target.querySelector('video')
       vid.classList.add('hover')
       vid.play()
  })
  grid.addEventListener('mouseleave', e=>
 {
  const vid = e.target.querySelector('video')
  vid.classList.remove('hover')
  vid.pause()
 })
})

  },[])
  return (
    <Screen className='mt-16'>
     <Grid className='grid-screen'>
       <div id='grid' data-src='lazy.mp4'  className={styles.grid}>
       <video className="lazy" id='preview1' autoPlay={false} muted={true} >
          <source src={Vid} data-src='lazy.mp4' type='video/mp4'/>
        </video>

       </div>
       <div id='grid'  className={styles.grid}>
       <video className="lazy" id='preview2'autoPlay={false} muted={true} >
          <source src={Vid2} type='video/mp4'/>
        </video>

       </div>
       <div id='grid'  className={styles.grid}>
        <video className="lazy" id='preview3' autoPlay={false} muted={true} >
          <source src={Vid3} type='video/mp4'/>
        </video>

       </div>
     </Grid>
     {/* Mobile View*/}
     <div className='mobile-view'>
     <Swiper  navigation={{
        prevEl: navigationPrevRef.current,
        nextEl: navigationNextRef.current,
      }}
     onBeforeInit={(swiper) => {
          swiper.params.navigation.prevEl = navigationPrevRef.current;
          swiper.params.navigation.nextEl = navigationNextRef.current;
     }}
        className="swip">
          <SwiperSlide>
          <GridMobile>
       <div id='grid' data-src='lazy.mp4'  className={styles.grid}>
       <video className="lazy" id='preview1' autoPlay={false} muted={true} >
          <source src={Vid} data-src='lazy.mp4' type='video/mp4'/>
        </video>
       </div>
       <div id='grid'  className={styles.grid}>
       <video className="lazy" id='preview2'autoPlay={false} muted={true} >
          <source src={Vid2} type='video/mp4'/>
        </video>
       </div>
     </GridMobile>
          </SwiperSlide>
          <SwiperSlide>
          <GridMobile>
          <div id='grid'  className={styles.grid}>
        <video className="lazy" id='preview3' autoPlay={false} muted={true} >
          <source src={Vid3} type='video/mp4'/>
        </video>
       </div>
       </GridMobile>
          </SwiperSlide>
        </Swiper>
        <div className='relative w-full'>
        <SwipButtons>
<div id='prev' ref={navigationPrevRef} >
    <Circle>
<svg className='prev-btn' width="24" height="24" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd"><path d="M2.117 12l7.527 6.235-.644.765-9-7.521 9-7.479.645.764-7.529 6.236h21.884v1h-21.883z"/></svg>
</Circle>
    </div>

<div id='next' ref={navigationNextRef} >
<Circle>
<svg className='next-btn' width="24" height="24" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd"><path d="M21.883 12l-7.527 6.235.644.765 9-7.521-9-7.479-.645.764 7.529 6.236h-21.884v1h21.883z"/></svg>
 </Circle>
    </div>
    </SwipButtons>
    </div>
        </div>


                {/*Mobile View 2 */}
                <div className='mobile-view-small'>
     <Swiper  navigation={{
        prevEl: navigationPrevRef.current,
        nextEl: navigationNextRef.current,
      }}
     onBeforeInit={(swiper) => {
          swiper.params.navigation.prevEl = navigationPrevRef.current;
          swiper.params.navigation.nextEl = navigationNextRef.current;
     }}
        className="swip">
          <SwiperSlide>
          <GridMobileSmall>
       <div id='grid' data-src='lazy.mp4'  className={styles.grid}>
       <video className="lazy" id='preview1' autoPlay={false} muted={true} >
          <source src={Vid} data-src='lazy.mp4' type='video/mp4'/>
        </video>
       </div>
     </GridMobileSmall>
          </SwiperSlide>
          <SwiperSlide>
          <GridMobileSmall>
          <div id='grid'  className={styles.grid}>
       <video className="lazy" id='preview2'autoPlay={false} muted={true} >
          <source src={Vid2} type='video/mp4'/>
        </video>
       </div>
       </GridMobileSmall>
          </SwiperSlide>
          <SwiperSlide>
          <GridMobileSmall>
          <div id='grid'  className={styles.grid}>
        <video className="lazy" id='preview3' autoPlay={false} muted={true} >
          <source src={Vid3} type='video/mp4'/>
        </video>
       </div>
       </GridMobileSmall>
          </SwiperSlide>
        </Swiper>
        <SwipButtons>
<div id='prev' ref={navigationPrevRef} >
    <Circle>
<svg className='prev-btn' width="24" height="24" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd"><path d="M2.117 12l7.527 6.235-.644.765-9-7.521 9-7.479.645.764-7.529 6.236h21.884v1h-21.883z"/></svg>
</Circle>
    </div>

<div id='next' ref={navigationNextRef} >
<Circle>
<svg className='next-btn' width="24" height="24" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd"><path d="M21.883 12l-7.527 6.235.644.765 9-7.521-9-7.479-.645.764 7.529 6.236h-21.884v1h21.883z"/></svg>
 </Circle>
    </div>
    </SwipButtons>
        </div>

    </Screen>

  )
}

export default Slide
